import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';
import ClipLoader from "react-spinners/ClipLoader";

import Api from '../../lib/seam-api';

import moment from 'moment';

const NoResults = ({ value = '' }) => {
    return (
        <div className="w-full h-[400px] flex justify-center items-center">
            <div className="flex flex-col gap-[10px] items-center justify-center">
                <img src="/assets/index/no-results.svg" className="h-[150px] mb-4" aria-label="No Results Image"/>
                <h2 class="leading-tight text-2xl font-extrabold text-gray-900 dark:text-white">No results found</h2>
                <p class="mb-4 font-normal text-base text-gray-500 dark:text-gray-400">We couldnt find any matches for <b>{ value }</b></p>
            </div>
        </div>
    )
}
class News extends Component {

    constructor(props) {
        super(props);
        this.state = {
            search : '',
            items : [],
            page: 1,
            pageCount : 0,
            cdnUrl : '/images',
            direction : 'desc',
            order: 'asc',
            tag: null,
            tags: []
        };

        this.searchCanceler = null;
    }

    onChangeHandler({target: { value }}) {
        this.setState({
            search : value
        }, () => this.changed());
    }

    componentDidMount() {
        this.fetchItems();
        this.loadTags();
    }

    loadTags() {
        Api.content().contentTypeTags(8).then(tags => {
            this.setState({tags  : tags.data})
        })
    }

    changed() {
        if(this.state.search.length >= 1) {
            return this.search();
        }

        this.fetchItems();
    }

    search() {
        this.setState({ loading: true })

        if(this.searchTimeOut) {
            clearTimeout(this.searchTimeOut);

        }
        if(this.searchCanceler !== null) {
            this.searchCanceler.cancel('Cancel Content Search');
            this.searchCanceler = null;
        }

        this.searchTimeOut = setTimeout(() => {
            Api.content().search(this.state.search, [ 8 ], this.state.tag !== null ? [ this.state.tag ] : [], searchCanceler => {
                this.searchCanceler = searchCanceler;
            }).then(response => {
                this.setState({
                    items : response.data,
                    pageCount : 0,
                    page : 1,
                    cdnUrl : response.meta.cdn_url,
                    loading: false
                })
            });
        }, 200);

    }

    fetchItems(page = this.state.page) {
        this.setState({ loading: true })

        Api.content().list(page, 10, [ 8 ], this.state.tag !== null ? [ this.state.tag ] : [], 'published', this.state.direction).then(response => {
            this.setState({
                items : response.data,
                pageCount : response.meta.last_page,
                cdnUrl : response.meta.cdn_url,
                loading: false,
            });
        })
    }

    handlePageClick(event) {
        this.setState({ page: event.selected + 1 }, () => this.fetchItems());

    }

    truncateDescription (input) {

        return input?.length > 65 ? `${input.substring(0, 65)}...` : input;

    }

    onTypeChange(event) {
        if (event.target.value === 'null') return this.setState({ tag: null });

        this.setState({ tag: event.target.value }, () => {
            this.changed();
        })
    }

    onOrder(event) {
        this.setState({ order: event.target.value }, () => {
            this.changed();
        })
    }

    onDirection(event) {
        this.setState({ direction: event.target.value }, () => {
            this.changed();
        })
    }

    renderFilters() {
        const renderOtherFilters = () => {
            // if (this.props.contentTypeSlug === 'service/grants') {
            //     return (
            //         <div class="flex gap-2">

            //         </div>
            //     )
            // }

            return null;
        }

        return (
            <div className="flex flex-row justify-between flex-wrap gap-4">
                <div class="relative w-[400px]">
                    <input type="search"
                        id="News Search Bar"
                        class="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50  md:rounded-l-none border-l-1 md:border-l-6 border border-gray-300"
                        placeholder="Search anything..." required onChange={this.onChangeHandler.bind(this)} value={this.state.search}/>
                    <button type="submit"
                        aria-label="Search Button"
                        class="h-[41.48px] w-[41.48px] flex justify-center items-center absolute top-0 right-0 p-2.5 text-sm font-medium text-white bg-primary-700 rounded-r-lg border border-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
                            { this.state.loading ?  <ClipLoader
                                color={'white'}
                                loading={true}
                                size={17}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            /> : <svg
                            class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                        </svg> }</button>
                </div>

                <div className="flex flex-row gap-4 flex-wrap">
                    { renderOtherFilters() }

                    <select onChange={this.onTypeChange.bind(this)} class="w-[200px] bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        <option value="null" selected>News Types</option>
                        { this.state?.tags?.map(type => <option value={type.id}>{ type.name }</option>)}
                    </select>

                    { this.state.search?.length === 0 && <>
                        <select onChange={this.onOrder.bind(this)} class="w-[200px] bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option value='published' selected>Published (Date)</option>
                            <option value='title'>Title (Alphabetical)</option>
                        </select>

                        <select onChange={this.onDirection.bind(this)} class="w-[200px] bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option value='asc'>Ascending</option>
                            <option value='desc' selected>Descending</option>
                        </select>
                    </>}
                </div>
            </div>
        )
    }

    render () {
        return (
            <div className='flex flex-col gap-16 py-8 px-4 mx-auto max-w-screen-xl'>

                { this.renderFilters() }


                    { this.state?.items?.length > 0 ? <div class="grid gap-12 sm:grid-cols-2 sm:gap-16 lg:gap-24 lg:grid-cols-3 xl:grid-cols-3">
                        { this.state?.items?.map(item => {
                        return (
                            <div class="bg-white border hover:border-0 hover:shadow-2xl border-gray-200 shadow-sm dark:bg-gray-800 dark:border-gray-700">
                                <a href={item?.slug?.includes('news/') ? item?.slug : `/news/${item?.slug}`} aria-label="Item Image Link">
                                    <div className="relative w-full h-[20rem] sm:h-[12rem] bg-cover" style={{
                                        backgroundImage: `url('${this.state.cdnUrl}/images/${item?.meta?.preview_image}')`,
                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                    }}>
                                         { item?.tags?.length > 0 && <div className="absolute top-4 left-4 flex gap-2 flex-wrap">
                                            { item?.tags?.map(tag => <span className="py-2 px-4 shadow-md no-underline rounded-full bg-gray-50 text-black font-sans font-semibold text-sm border-blue btn-primary hover:text-white hover:bg-blue-light focus:outline-none active:shadow-none mr-2">{ tag?.name }</span>) }
                                    </div>}
                                    </div>
                                </a>
                                <div class="h-[calc(100%_-_20rem)] sm:h-[calc(100%_-_12rem)] px-5 py-5 flex flex-col justify-between">
                                    <div className="flex flex-col">
                                        { item?.title && <h2 class="mb-4 leading-tight text-2xl font-extrabold text-gray-900 dark:text-white">{ item?.title }</h2> }

                                        <p class="mb-3 font-normal text-gray-700 dark:text-gray-400">{ moment(item?.published)?.format('LLLL') }</p>
                                            
                                        { item?.meta?.preview_description && <p class="mt-3 mb-4 font-normal text-base text-gray-500 dark:text-gray-400">{ item?.meta?.preview_description?.substr(0, 200) }</p> } 
                                    </div>
                                
                                    <a href={item?.slug?.includes('news/') ? item?.slug : `/news/${item?.slug}`} aria-label={`Read more about ${item?.title}`} role="link" class="w-fit text-white bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                        Read More
                                        <svg aria-hidden="true" class="w-5 h-5 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                                    </a> 
                                </div>
                            </div>
                            )
                        }) } </div> : !this.state.loading && <NoResults value={this.state.search}/> }


                { this.state?.items?.length > 0 && <div class="flex justify-center w-full px-4 mx-auto max-w-screen-xl">
                    <ReactPaginate
                        breakLabel="..."
                        onPageChange={this.handlePageClick.bind(this)}
                        pageRangeDisplayed={5}
                        pageCount={this.state.pageCount}
                        nextLabel={
                            <>
                                <span class="sr-only">Previous</span>
                                <svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
                            </>
                        }
                        previousLabel={
                            <>
                                <span class="sr-only">Next</span>
                                <svg aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>
                            </>
                        }
                        renderOnZeroPageCount={null}
                        containerClassName="pagination"
                    />
                </div> }
            </div>
        )
    }
}

export default News;

document.addEventListener('readystatechange', () => {
    const element = document.getElementById('news-index')

    if (element) {
        ReactDOM.render(<News/>, element);
    }
});
